/**
 * Enregistrement du service worker et mise a jour proposee a l'employe.
 *
 * Une nouvelle version installee attend (`registration.waiting`). La page
 * l'annonce (onUpdateReady) ; elle ne prend la main que quand l'employe
 * appuie sur « Recharger » (applyUpdate), et seulement entre deux ventes :
 * c'est l'ecran qui decide de montrer le bouton.
 */
export const SW_URL = '/sw.js';

// Meme valeur que swPolicy.MESSAGE_SKIP_WAITING (verifie par les tests) :
// importer swPolicy ici le partagerait entre l'app et sw.js, qui doit rester
// un fichier autonome (vite.config.mjs).
export const MESSAGE_SKIP_WAITING = 'CAISSE_SKIP_WAITING';

/**
 * @param {object} options
 * @param {Navigator} [options.nav]
 * @param {() => void} options.onUpdateReady
 * @param {() => void} [options.reload]
 * @returns {null | { ready: Promise<ServiceWorkerRegistration|null>, checkForUpdate: () => Promise<void>, applyUpdate: () => boolean }}
 */
export function registerServiceWorker({ nav = globalThis.navigator, onUpdateReady, reload }) {
    if (!nav || !nav.serviceWorker) return null;
    const container = nav.serviceWorker;
    const doReload = reload || (() => globalThis.location.reload());
    let registration = null;

    const announceIfWaiting = () => {
        // Sans controleur, c'est la premiere installation : rien a proposer.
        if (registration && registration.waiting && container.controller) onUpdateReady();
    };

    const ready = container.register(SW_URL, { scope: '/', updateViaCache: 'none' })
        .then((reg) => {
            registration = reg;
            announceIfWaiting();
            reg.addEventListener('updatefound', () => {
                const installing = reg.installing;
                if (!installing) return;
                installing.addEventListener('statechange', () => {
                    if (installing.state === 'installed') announceIfWaiting();
                });
            });
            return reg;
        })
        .catch(() => null);

    return {
        ready,
        async checkForUpdate() {
            if (!registration) return;
            try {
                await registration.update();
            } catch (_error) {
                // Hors ligne : on reessaiera au prochain retour en ligne.
            }
        },
        applyUpdate() {
            const waiting = registration && registration.waiting;
            if (!waiting) return false;
            container.addEventListener('controllerchange', () => doReload(), { once: true });
            waiting.postMessage({ type: MESSAGE_SKIP_WAITING });
            return true;
        },
    };
}
